import { useInfiniteQuery } from '@tanstack/react-query';

import { listJudgeVerdicts, type JudgeVerdictsParams } from '../services/api/judge';

const PAGE_SIZE = 50;

// Filtren bor i URL:en och byter frågenyckel. useInfiniteQuery börjar då om från
// första sidan av sig själv; med en markör i eget state som i useTicketList
// skulle en gammal markör följa med in i det nya filtret.
export const useJudgeVerdicts = (params: Omit<JudgeVerdictsParams, 'limit' | 'cursor'>) => {
  const query = useInfiniteQuery({
    queryKey: ['judge-verdicts', params],
    queryFn: ({ pageParam }) =>
      listJudgeVerdicts({ ...params, limit: PAGE_SIZE, cursor: pageParam }),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (last) => last.nextCursor ?? undefined,
    retry: false,
  });

  const pages = query.data?.pages ?? [];
  return {
    items: pages.flatMap((page) => page.items),
    total: pages[0]?.total ?? null,
    hasMore: query.hasNextPage,
    isLoading: query.isLoading,
    isFetchingMore: query.isFetchingNextPage,
    error: query.error,
    loadMore: () => void query.fetchNextPage(),
  };
};
